const helpers = {
    'ui/dataEntry/connectionType': params => {
        let typeLabel = 'N/A'
        const connectionType = {
            SFTP: ['sftp', 'sftp_key', 'sftp_pwd'],
            FTP: ['ftp'],
            'Amazon S3': ['s3'],
            'Google Cloud': ['gcloud']
        }

        for (const label in connectionType) {
            if (connectionType[label].indexOf(params.type) > -1) {
                typeLabel = label
            }
        }
        return typeLabel
    },
    'ui/dataEntry/jobType': params => {
        let typeLabel = 'N/A'
        const type = {
            CRM: ['["cb2"]', '["cb_produit"]', '["crm_lesechos"]'],
            Partner: ['["partner"]'],
            Proxy: ['["wam_proxy"]'],
            Facebook: ['["fb"]'],
            'Offline Datalayer': ['["crm"]']
        }

        for (const label in type) {
            if (type[label].indexOf(params.type) > -1) {
                typeLabel = label
            }
        }
        return typeLabel
    },

    'ui/dataEntry/insertNodeTree': params => {
        const childrenTree = []

        if (typeof params.item['childrenIds'] !== 'undefined') {
            for (const childId of params.item['childrenIds']) {
                if (typeof params.items[childId] !== 'undefined') {
                    childrenTree.push(
                        helpers['ui/dataEntry/insertNodeTree']({
                            items: params.items,
                            item: params.items[childId]
                        })
                    )
                }
            }
        }

        const nodeTree = params.item

        delete nodeTree['childrenIds']

        if (childrenTree.length > 0) {
            nodeTree['children'] = childrenTree
        } else {
            delete nodeTree['children']
        }

        return nodeTree
    }
}

export default helpers
